// lazy loading Components
export default (page) => () => import(`@/views/pages/${page}.vue`)
